import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared account-popover row: link MenuItem with icon + body2 label.
 * Nested icon minWidth beats MenuItem's default 36px column.
 * Color inherit avoids Bootstrap `a:hover` blue on Link MenuItems.
 */
const menuItemSx = {
  color: 'inherit',
  typography: 'body2',
  minHeight: 40,
  py: 1,
  '&:hover': { color: 'inherit' },
  '&& .MuiListItemIcon-root': { minWidth: 28 },
} as const;

export type SidenavAccountMenuItemProps = {
  to: string;
  icon: ReactNode;
  label: string;
  onClick?: () => void;
};

/**
 * Action row used in the account popover (logout, impersonation, etc.).
 */
export function SidenavAccountMenuItem({ to, icon, label, onClick }: SidenavAccountMenuItemProps) {
  return (
    <MenuItem component={Link} to={to} onClick={onClick} sx={menuItemSx}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} slotProps={{ primary: { variant: 'body2' } }} />
    </MenuItem>
  );
}
